import { filterXSS, whiteList as externalXSSWhitelist } from 'xss';
const ALLOWED_PREFIX_ATTRIBUTES = ['data', 'aria'];
const ALLOWED_ATTRIBUTES = ['style', 'class', 'id', 'dir', 'wix-comp', 'role', 'tabindex', 'focus', 'contenteditable', 'spellcheck', 'scope'];
const ALLOWED_LINK_ATTRIBUTES = ['href', 'dataquery', 'id', 'rel', 'target', 'class', 'style'];
const CSS_PROPS_WHITELIST = ['color', 'background-color', 'font-size', 'font-family', 'font-style', 'text-decoration', 'writing-mode', 'text-orientation', 'line-height', 'text-shadow', 'direction', 'position', 'z-index', 'top', 'bottom', 'left', 'right', 'overflow', 'overflow-x', 'overflow-y', 'height', 'width', 'max-height', 'max-width'];
function generateHTMLWhiteList() {
  const whitelist = {
    ...externalXSSWhitelist,
    strike: [],
    hatul: [],
    wline: [],
    object: []
  };

  /* istanbul ignore next */
  if (whitelist.a) {
    whitelist.a.push(...ALLOWED_LINK_ATTRIBUTES);
  }
  Object.keys(whitelist).forEach(key => {
    /* istanbul ignore next */
    if (!whitelist[key]) {
      whitelist[key] = [];
    }
    whitelist[key].push(...ALLOWED_ATTRIBUTES);
  });
  return whitelist;
}
function generateCSSWhiteList() {
  return CSS_PROPS_WHITELIST.reduce((acc, key) => {
    acc[key] = true;
    return acc;
  }, {});
}
const XSSWhitelist = generateHTMLWhiteList();
const CSSWhitelist = generateCSSWhiteList();
export function sanitizeHTML(html) {
  return filterXSS(html, {
    whiteList: XSSWhitelist,
    stripIgnoreTagBody: ['script', 'style'],
    stripBlankChar: true,
    css: {
      whiteList: {
        ...externalXSSWhitelist,
        ...CSSWhitelist
      }
    },
    onIgnoreTagAttr(_tag, name, value) {
      /* istanbul ignore else */
      if (ALLOWED_PREFIX_ATTRIBUTES.some(prefix => name.startsWith(prefix))) {
        return `${name}="${value}"`;
      }

      /* istanbul ignore next */
      return '';
    },
    onIgnoreTag() {
      return '';
    }
  });
}
//# sourceMappingURL=sanitizeHTML.js.map